module.exports = __webpack_public_path__ + "static/media/4 axe tattoo viking norse neck tattoo.1280x1707.a38aebc2.webp";